import dayjs from 'dayjs'

// https://day.js.org/docs/en/display/format
export function formatDate (date = new Date(), format = 'DD-MM-YYYY') {
  return dayjs(date).format(format)
}

export function lastDayOfMonth (date = new Date()) {
  return dayjs(date).daysInMonth()
}

export function parseDate (date) {
  return dayjs(date).toDate()
}

export function duration (endDate, startDate) {
  const timeInMs = dayjs(endDate).diff(dayjs(startDate), 's')

  if (timeInMs) {
    const hours = Math.floor(timeInMs / 3600)
    const minutes = Math.floor((timeInMs - hours * 3600) / 60)
    const seconds = Math.floor(timeInMs - minutes * 60 - hours * 3600)

    return hours.toString().padStart(2, '0') + ':' +
      minutes.toString().padStart(2, '0') + ':' +
      seconds.toString().padStart(2, '0')
  }

  return '00:00:00'
}

// https://day.js.org/docs/en/manipulate/add
export function addSeconds (date, seconds) {
  return dayjs(date).add(seconds, 's').toDate()
}

export function addMonths (date, months) {
  return dayjs(date).add(months, 'M').toDate()
}

// https://stackoverflow.com/a/6682423
function extractTimestamp (date) {
  return parseInt(date.match(/\/Date\(([0-9]+)(?:.*)\)\//)[1])
}

export function transformDate (date, returnFormatted = true) {
  if (!date) {
    return returnFormatted ? 'never' : null
  }

  if (!['object', 'string'].includes(typeof date) ||
    (typeof date === 'object' && (!{}.hasOwnProperty.call(date, 'DateTime') || typeof date.DateTime !== 'string'))) {
    throw new Error('transformDate: wrong date passed')
  }

  let dateObj
  if (typeof date === 'string' && date.startsWith('/Date(')) {
    dateObj = new Date(extractTimestamp(date))
  } else if (typeof date === 'object') {
    dateObj = new Date(extractTimestamp(date.DateTime))
  } else {
    dateObj = parseDate(date)
  }

  return returnFormatted ? formatDate(dateObj, 'DD-MM-YYYY HH:mm:ss') : dateObj
}
